import {TConsentModeMode} from "services-comun-meteored/modules/services/cmp/interface";
import {Provider} from "./provider/provider";
import {AndroidProvider} from "./provider/android-provider";
import {IOSProvider} from "./provider/i-o-s-provider";
import {GPTProvider} from "./provider/g-p-t-provider";
import {log} from "../util/log";
import {GtagProvider} from "./provider/gtag-provider";

export class ConsentMode {
    /* STATIC */
    public static create(consent: boolean): ConsentMode {
        return new ConsentMode(consent);
    }

    /* INSTANCE */
    private constructor(private readonly _consent: boolean) {
    }

    private get consent(): boolean {
        return this._consent;
    }

    public configure(type: TConsentModeMode): void {
        log.debug(`Configurando ConsentMode para ${type}`);
        let provider: Provider|undefined = undefined;
        switch (type) {
            case TConsentModeMode.GPT:
                provider = new GPTProvider();
                break;
            case TConsentModeMode.GTAG:
                provider = new GtagProvider();
                break;
            case TConsentModeMode.ANDROID:
                provider = new AndroidProvider();
                break;
            case TConsentModeMode.IOS:
                provider = new IOSProvider();
                break;
        }

        if (provider) {
            provider.configure(this.consent);
        }
    }
}
